import React from "react";
import getPercentileColor from "../../util/getPercentileColor";
import { useTranslation } from "react-i18next";
import TutorAssignmentButton from "../../../../features/tutor_assignment/components/TutorAssignmentButton";

const grades = {
  PRE_K: "Pre-K",
  KINDERGARTEN: "K",
  FIRST_GRADE: "1",
  SECOND_GRADE: "2",
  THIRD_GRADE: "3",
  FOURTH_GRADE: "4",
  FIFTH_GRADE: "5",
};

const seasons = {
  FALL: "Fall",
  SUMMER: "Summer",
  SPRING: "Spring",
  WINTER: "Winter",
};

export default function SkillContent(props) {
  const { data } = props;

  const {t} = useTranslation("skills_status_report");

  const {
    mastery,
    skillAREAScore = {},
    description,
    examples,
    standard,
  } = data;

  const exposureCount = data.exposureCount || 0;
  const errorCount = data.errorCount || 0;

  let skillGradeLevel = "n/a";
  if (skillAREAScore && skillAREAScore.grade) {
    const { grade, period } = skillAREAScore;
    if (grade && period)
      skillGradeLevel = `${t(grades[grade])} – ${t("common:"+seasons[period])}`;
  }

  let color = getPercentileColor(mastery.pacing);
  if (!mastery.pacing) color = "#555";

  let label = t("Not Developed");
  if (mastery.pacing === "AT_GRADE_LEVEL") label = t("Developing");
  if (mastery.pacing === "AHEAD_OF_GRADE_LEVEL") label = t("Mastered");

  return (
    <div className="skill-content">
      {renderStandards()}
      <div className="observation-box" style={{ borderColor: color }}>
        <div className="observation-label" style={{ color }}>
          {label}
        </div>
        <div style={{ padding: "6px 40px" }}>
          <div className="observation-row">
            <span className="circle" style={{ background: color }}></span>
            <div>{exposureCount} {t("observation", {count: exposureCount})}</div>
          </div>
          <div className="observation-row">
            <span className="circle" style={{ background: color }}></span>
            <div>{errorCount} {t("error", {count: errorCount})}</div>
          </div>
        </div>
      </div>
      <div style={{ marginBottom: 10 }}>
        <div className="mastery">
          <div>{t("Skill Level")}:</div>
          <div>{skillGradeLevel}</div>
        </div>
      </div>
      {!!description && <div className="description">{description}</div>}
      {!!examples && <div className="example">{examples} </div>}
    </div>
  );

  function renderStandards() {
    if (!standard) return;
    return (
      <div className="standards">
        {standard.map((x) => (
          <div key={x} style={{ marginBottom: 4 }}>
            {x}
          </div>
        ))}
      </div>
    );
  }
}
